import classNames from 'classnames'
import { useEffect, useState } from 'react'

import classes from './FamilyEnrollmentsPage.module.scss'
import FilterButton from './components/FilterButton'
// import LoadingSpinner from '../common/loader/legacy-loaders/LoadingSpinner'
import MembersEnrollmentsTable from './components/MembersEnrollmentsTable'
import { useOutletContext } from 'react-router-dom'
import Loader from '../common/loader/Loader'

const FILTER_OPTIONS = {
  ALL: 'ALL',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
}

const FamilyEnrollmentsPage = () => {
  const { family } = useOutletContext()
  const [enrollments, setEnrollments] = useState(null)
  const [filterOption, setFilterOption] = useState(FILTER_OPTIONS.ALL)

  const handleFilter = (option) => {
    setFilterOption(option)

    if (option !== FILTER_OPTIONS.ALL) {
      setEnrollments(family.enrollments.filter(enrollment => enrollment.status.toLowerCase() === option.toLowerCase()))
    } else {
      setEnrollments(family.enrollments)
    }
  }

  useEffect(() => {
    setEnrollments(family.enrollments)
  }, [family])

  if (!enrollments) {
    return (
      <div className='h-100 d-flex align-items-center justify-content-center'>
        <Loader>Loading Family Enrollments</Loader>
      </div>
    )
  }

  return (
    <main className={classes.wrapper}>
      <header className='py-4 d-flex align-items-center'>
        <div className={classes.searchWrapper}>
          <h4 className={classNames('font-weight-bold mb-0', classes.title)}>
            Enrollments ({enrollments?.length})
          </h4>
        </div>
        <div className={classes.filterOptions}>
          <FilterButton
            text='All'
            onClick={() => handleFilter(FILTER_OPTIONS.ALL)}
            isActive={filterOption === FILTER_OPTIONS.ALL}
          />
          <FilterButton
            text='Active'
            onClick={() => handleFilter(FILTER_OPTIONS.ACTIVE)}
            isActive={filterOption === FILTER_OPTIONS.ACTIVE}
          />
          <FilterButton
            text='Completed'
            onClick={() => handleFilter(FILTER_OPTIONS.COMPLETED)}
            isActive={filterOption === FILTER_OPTIONS.COMPLETED}
          />
        </div>
      </header>
      <MembersEnrollmentsTable enrollments={enrollments} />
    </main>
  )
}

export default FamilyEnrollmentsPage
